import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import { ActivatedRoute } from '@angular/router';
import {
  ActivitiesCompany,
  CompanyInfoSii,
  CompanyMPSummary,
  CompanyUserAssignment,
  InfoClient,
  InfoCompany,
  SummaryCompany,
} from '../../interface/company-client.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FogapeInfoClient } from '../../interface/fogape-client.interface';
import { ScoringIngeService } from '../../service/scoring-inge.service';
import { LegacyScoring } from '../../interface/legacy-scoring';
import { UpdateInformationComponent } from '../../modals/update-information/update-information.component';
import { finalize, Observable } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { C } from '@angular/cdk/keycodes';
import { AddNewContactComponent } from '../../modals/add-new-contact/add-new-contact.component';
import { CompanyCorporateMeshModalComponent } from '../../modals/company-corporate-mesh-modal/company-corporate-mesh-modal.component';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})
export class InformationComponent {
  public infoLegacy: LegacyScoring;
  public info: InfoCompany;
  public infoSii: CompanyInfoSii;
  infoClientTable: InfoClient[];
  public summaries?: SummaryCompany;
  public activEcon?: ActivitiesCompany;
  public spinnerShow: boolean = false;
  public spinnerMP: boolean = false;
  @Output() sendBoolean = new EventEmitter<boolean>();
  @Output() SGRScoringState = new EventEmitter<number>();
  displayedColumns: string[] = ['description', 'startDate', 'endDate', 'iva', 'economicActivityCode'];
  public dataSource!: MatTableDataSource<ActivitiesCompany>;
  public existeActividadEconomica: boolean;
  public url: number
  @Input() fogapeInfo?: FogapeInfoClient;
  @Input() receiveBooleanOwners:boolean;
  @Input() companyId: number;
  @Input() portafolio?: CompanyUserAssignment;
  public fogape: FogapeInfoClient;
  public MPDashboardUrl: SafeResourceUrl | undefined;
  public clientMP: CompanyMPSummary | null;

  constructor(
    private serviceInfo: ServiceInfoClientService,
    private serviceScoring: ScoringIngeService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer

  ) {
    this.clientMP = null;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params: any) => {
      const { client } = params;
      const id = client || this.companyId;
      const rut = parseInt(id);
      this.url = parseInt(id);
      this.getInfo(rut);
      this.getInfoSii(rut);
      this.getCompanyMPInfo(rut);      

      
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.fogape = changes['fogapeInfo']?.currentValue;
  }

  getCompanyMPInfo(companyId: number) {
    this.spinnerMP = true;
    this.serviceInfo.getCompanyMercadoPublicoInfo(companyId)
      .pipe(
        finalize(() => this.spinnerMP = false)
      )
      .subscribe({
        next: (res) => this.clientMP = res
      })
  }



  getInfo(rut: number) {
    this.serviceInfo.infoCompany(rut).subscribe((e) => {
      
      this.info = e;
      console.log(this.info);
      this.activEcon = e.activities;
      let url = 'https://dashboard-inge-qa.azurewebsites.net/dashboardlicitacion?rut=' + e.rut;
      this.MPDashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.dataSource = new MatTableDataSource<ActivitiesCompany>(e.activities);
      if (e.activities.length == 0) {
        this.existeActividadEconomica = false;
      } else {
        this.existeActividadEconomica = true;
      }
      this.getLegacyData();
    });
  }

  updateInfo(rutUrl: InfoCompany) {
    {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.panelClass = 'container_form_debts'
      dialogConfig.data = rutUrl;

      const dialogRef = this.dialog.open(
        UpdateInformationComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((res: boolean) => {
        if (res){           
          this.sendBoolean.emit(res)
          this.getInfo(this.url)};
      });
    }
  }

  getLegacyData() {
    var r = this.info?.rut;
    const rut = r.replaceAll('.', '');
    this.serviceScoring.getLegacyData(rut).subscribe({
      next: (e) => {
        this.infoLegacy = e;
        this.SGRScoringState.emit(e?.lastScoringState)
        console.log(e);
      },
      error: () => {
      },
      complete: () => {
      },
    });
  }

  getInfoSii(rut: number) {
    this.serviceInfo.getInfoSiiCompany(rut).subscribe({
      next: (e) => {
        this.infoSii = e;     
      },
      error: () => {
      },
      complete: () => {
      },
    });
  }

  public openCompanyMeshModal(companyId: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '80vw';
    dialogConfig.height = '98vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '98vh';
    dialogConfig.data = companyId;
    this.dialog.open(CompanyCorporateMeshModalComponent, dialogConfig);
  }

  public enableCompanyMesh(): boolean {
    const userAgent = navigator.userAgent.toLocaleLowerCase();
    return /safari/.test(userAgent) && !/chrome/.test(userAgent);
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
  
  touchStart(event: TouchEvent): void {
    event.stopPropagation();
  }
  
  touchMove(event: TouchEvent): void {
    event.stopPropagation();
  }
  
  touchEnd(event: TouchEvent): void {
    event.stopPropagation();
  }

}
